'use client';

import { useRouter } from "next/navigation";
import { useCallback } from "react";

/**
 * React Router-compatible navigate shim for Next.js.
 * Returns a function with the same API as react-router's useNavigate.
 *
 *   const navigate = useNavigate();
 *   navigate("/foo");                // push
 *   navigate("/foo", { replace: true }); // replace
 *   navigate(-1);                    // back
 *   navigate(1);                     // forward
 */
export function useNavigate() {
  const router = useRouter();

  return useCallback(
    (to, options) => {
      if (to === undefined || to === null) return;
      if (typeof to === "number") {
        if (to < 0) router.back();
        else if (to > 0) router.forward();
        return;
      }
      if (options?.replace) {
        router.replace(to);
      } else {
        router.push(to);
      }
    },
    [router]
  );
}

export default useNavigate;
